


















import { Vue, Component, Prop } from "vue-property-decorator";
import { User } from "@/components/User";
import { ICodeList, IThaiArea, IMapFilter } from "@/components/map/types";
import { isMobile, isEmptyObject } from "@/common/utils";
import Map from "@/components/map/Map";

const MAP_EXTENT = [95.854, 5.299, 106.064, 20.533];

@Component
export default class DataFilter extends Vue {
  @Prop({
    default: null
  }) data: {
    $map: Map;
    filter: IMapFilter
  };

  $map: Map;
  filter: IMapFilter = {
    Source: "GISagro",
    Keyword: null,
    ProvinceCode: null,
    AmphoeCode: null,
    TambonCode: null,
    CropType: null,
    CropGenus: null,
    CropSpecies: null,
    DeedType: null,
    GrowOrHarvest: null,
    GrowOrHarvestYear: null,
    AreaType: null,
    Area1: {
      Rai: null,
      Ngan: null,
      SqWah: null
    },
    Area2: {
      Rai: null,
      Ngan: null,
      SqWah: null
    }
  }

  get language() : string {
    return this.$store.getters.Language;
  };

  get User() : User {
    return this.$store.getters.User;
  };

  get WindowWidth() : number {
    return this.$store.getters.WindowWidth;
  }

  get isSmallOrMobile() : boolean {
    return isMobile() || this.WindowWidth<600;
  }

  created() {
    if (this.data) {
      this.$map = this.data.$map;
      this.filter = this.data.filter;
    }
  }

  closeMe(me:string) {
    this.$emit('iWantToDo', {
      name: 'toggle_toc',
      data: me
    });
  }

}
